import React from "react";

import { Step } from "../../../../../types/GameTypes";

import cornerNW from "./corner-nw.png";
import cornerNE from "./corner-ne.png";
import cornerSE from "./corner-se.png";
import cornerSW from "./corner-sw.png";
import loopN from "./loop-n.png";
import loopE from "./loop-e.png";
import loopS from "./loop-s.png";
import loopW from "./loop-w.png";
import straightHorizontal from "./straight-horizontal.png";
import straightVertical from "./straight-vertical.png";

const movementToImage: { [key: string]: string } = {
  NORTH2NORTH: straightVertical,
  NORTH2EAST: cornerSE,
  NORTH2SOUTH: loopN,
  NORTH2WEST: cornerSW,

  EAST2EAST: straightHorizontal,
  EAST2SOUTH: cornerSW,
  EAST2WEST: loopE,
  EAST2NORTH: cornerNW,

  SOUTH2SOUTH: straightVertical,
  SOUTH2WEST: cornerNW,
  SOUTH2NORTH: loopS,
  SOUTH2EAST: cornerNE,

  WEST2WEST: straightHorizontal,
  WEST2NORTH: cornerNE,
  WEST2EAST: loopW,
  WEST2SOUTH: cornerSE,
};

function stepToImage(step: Step): string {
  return movementToImage[`${step.starting}2${step.ending}`];
}

type Props = {
  step: Step;
};

function GameBoardCellMovement({ step }: Props) {
  return (
    <>
      <img src={stepToImage(step)} alt="step" className="step" />
    </>
  );
}

export default GameBoardCellMovement;
